import { useMutation, useQueryClient } from "@tanstack/react-query";
import momentsClient, {
  CreateMomentOccasionPayload,
  UpdateMomentOccasionPayload,
} from "../../../../api/moments";
import { MOMENT_OCCASIONS_QUERY_KEY } from "./useMomentOccasionsQuery";

// Creates the occasion when `isNew`, otherwise updates it, then uploads the
// logo if a new file was picked (the logo has its own endpoint).
export type SaveMomentOccasionInput =
  | { isNew: true; payload: CreateMomentOccasionPayload; logoFile?: string }
  | {
      isNew: false;
      key: string;
      payload: UpdateMomentOccasionPayload;
      logoFile?: string;
    };

const useSaveMomentOccasionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: SaveMomentOccasionInput) => {
      const saved = input.isNew
        ? await momentsClient.createOccasion(input.payload)
        : await momentsClient.updateOccasion(input.key, input.payload);
      return input.logoFile
        ? momentsClient.uploadOccasionLogo(saved.key, input.logoFile)
        : saved;
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: MOMENT_OCCASIONS_QUERY_KEY }),
  });
};

export default useSaveMomentOccasionMutation;
